export default "__VITE_ASSET__DPxVZKa$__"